import scssConstants from './variables.module.scss';

export const styleConstants = {
    priceRowHeight: parseInt(scssConstants.priceRowHeight),
    priceChangeRowHeight: parseInt(scssConstants.priceChangeRowHeight),
    priceChangeRowPaddingBottom: parseInt(
        scssConstants.priceChangeRowPaddingBottom
    ),
};
